import React from "react";
import { Button } from "../ui/Button";
import { ProductCarousel } from "../ui/ProductCarousel";

interface Hook2SectionProps {
  heading: string;
  subheading?: string;
  productImages: string[];
  ctaText: string;
  onCtaClick: () => void;
}

export function Hook2Section({
  heading,
  subheading,
  productImages,
  ctaText,
  onCtaClick,
}: Hook2SectionProps) {
  return (
    <section className="bg-black py-20 px-4">
      <div className="w-full lg:w-[92%] mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#fbbf24]">
            {heading}
          </h2>

          {/* Subheading */}
          {subheading && (
            <p className="text-lg sm:text-xl text-gray-300 max-w-2xl -mt-4">
              {subheading}
            </p>
          )}

          {/* Product Carousel */}
          <ProductCarousel images={productImages} />

          {/* CTA Button */}
          <div className="flex justify-center mt-6">
            <Button variant="primary" size="lg" onClick={onCtaClick}>
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
